import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const cardContent: SxStyle = {
  backgroundColor: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0.5),
  border: (p) => `solid 1px ${p.palette.grey[300]}`,
};

export const divider: SxStyle = {
  marginY: 1.5,
};

export const alert: SxStyle = {
  marginTop: 1.5,
};
